import { DataSerializeType } from '../../interceptors/dataSerializer';
import { AuthType } from '../../interceptors/auth';

/**
* @param {import('axios').AxiosInstance} forgeRockAxiosInstance
*/
export default function device(forgeRockAxiosInstance) {
  /**
   * @typedef RenewForgerockTokenParams
   * @type {object}
   * @property {string} username
   * @property {string} refresh_token
   */
  /**
   * @param {RenewForgerockTokenParams} renewForgerockTokenParams
   */
  async function renewToken({ scope, ...renewForgerockTokenParams }) {
    return forgeRockAxiosInstance.post('/openam/oauth2/realms/root/realms/ssla/access_token', {
      grant_type: 'refresh_token',
      scope: scope || 'profile openid entitlements status',
      ...renewForgerockTokenParams,
    }, {
      dataSerializeType: DataSerializeType.FORM_URL_ENCODED,
      authType: AuthType.API_TOKEN_BASIC,
    });
  }

  async function logout() {
    return forgeRockAxiosInstance.post('/openam/json/realms/root/realms/ssla/sessions/?_action=logout', {}, {
      authType: AuthType.SSO_TOKEN,
    });
  }

  return {
    renewToken,
    logout,
  };
}
